import { render, staticRenderFns } from "./KisiKurumSorgulaView.vue?vue&type=template&id=333a7500"
import script from "./KisiKurumSorgulaView.vue?vue&type=script&lang=ts"
export * from "./KisiKurumSorgulaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports